import { brand } from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.div `
  background-color: ${brand.white};
  padding: 24px 24px 30px;
  border-radius: 6px;
  width: 100%;
`;
const List = styled.ul `
  display: grid;
  gap: 16px;

  @media ${from(Device.TabletLarge)} {
    grid-template-columns: 1fr 1fr;
    gap: 24px 32px;
  }
`;
const Item = styled.li `
  flex: 1 1 50%;
`;
const Link = styled.a `
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  color: ${brand.black};
  ${fonts.montserrat.semiBold};

  @media ${from(Device.MobileLarge)} {
    font-size: 18px;
  }

  &:hover {
    text-decoration: none;
  }

  svg {
    width: 17px;
  }
`;
const Title = styled.h2 `
  font-size: 20px;
  color: ${brand.black};
  ${fonts.montserrat.extraBold};
  margin-bottom: 24px;

  @media ${from(Device.MobileLarge)} {
    font-size: 22px;
  }
`;
const SectionLinksStyles = {
    Container,
    Item,
    Link,
    List,
    Title,
};
export default SectionLinksStyles;
